// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2RH8h","title":"FrontImage_title__2XQfu"};